/**
 * @generated SignedSource<<d30ed351f1e584f6c59754920263381f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteFixedPriceLockInput = {
  projectId?: string | null;
  fixedPriceLockId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteFixedPriceLockMutation$variables = {
  input: DeleteFixedPriceLockInput;
};
export type deleteFixedPriceLockMutation$data = {
  readonly deleteFixedPriceLock: {
    readonly deleteFixedPriceLockId: string;
  } | null;
};
export type deleteFixedPriceLockMutation = {
  variables: deleteFixedPriceLockMutation$variables;
  response: deleteFixedPriceLockMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteFixedPriceLockPayload",
    "kind": "LinkedField",
    "name": "deleteFixedPriceLock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleteFixedPriceLockId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteFixedPriceLockMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteFixedPriceLockMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e1f67b0cee2b5f0a003a01063d9fb91a",
    "id": null,
    "metadata": {},
    "name": "deleteFixedPriceLockMutation",
    "operationKind": "mutation",
    "text": "mutation deleteFixedPriceLockMutation(\n  $input: DeleteFixedPriceLockInput!\n) {\n  deleteFixedPriceLock(input: $input) {\n    deleteFixedPriceLockId\n  }\n}\n"
  }
};
})();

(node as any).hash = "e227dca46e1752fb5839d8672cf36b92";

export default node;
